<template>
    <div class="np-form-user-fields">
        <new-payment-form-field
            field="payment-form-email"
            v-model="form.email"
            :validation="$v.form.email"
            label="Email*"
            @change-input="checkValid"
            :mask="!isTouchDevice ? 'customEmail' : ''"
            :autocomplete-type="'email'"
        />
        <new-payment-form-field
            field="payment-form-phone"
            v-model="form.phone"
            :validation="$v.form.phone"
            label="Телефон*"
            :mask="!isIe() ? 'phone' : ''"
            @change-input="checkValid"
            :autocomplete-type="'phone'"
        />
        <new-payment-form-field
            field="payment-form-amount"
            v-model="form.paymentAmount"
            :validation="$v.form.paymentAmount"
            label="Сумма платежа*"
            @change-input="checkValid"
            :mask="!isIe() ? 'sumFull' : ''"
            :autocomplete-type="'off'"
        />
        <new-payment-form-field
            v-if="formType !== 'pnd'"
            field="payment-form-address"
            v-model="form.address"
            :validation="$v.form.address"
            label="Адрес регистрации"
            @change-input="checkValid"
            :autocomplete-type="'off'"
        />
        <new-payment-form-field
            v-if="formType !== 'pnd'"
            field="payment-form-account"
            v-model="form.account"
            :validation="$v.form.account"
            label="Номер счета"
            @change-input="checkValid"
            :autocomplete-type="'off'"
        />
        <new-payment-form-field
            v-if="formType !== 'pnd'"
            field="payment-form-contract"
            v-model="form.contract"
            :validation="$v.form.contract"
            label="Номер договора"
            @change-input="checkValid"
            :autocomplete-type="'off'"
        />
    </div>
</template>

<script>
import { required, maxLength, email } from 'vuelidate/lib/validators';
import '@/assets/js/InputmaskAliases';
import NewPaymentFormField from "@/components/new-payment-form/NewPaymentFormField";

const validations = {
    onlyLetters(value) {
        return (/^[A-Za-zА-Яа-яЁё]([A-Za-zА-Яа-яЁё  \-]+)?$/).test(value);
    },
    correctDate(value) {
        return (/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/i).test(String(value));
    }
};

export default {
    name: "NewPaymentFormContactsFields",
    components: {
        NewPaymentFormField
    },
    props: {
        contactsInfo: {
            default: false
        },
        formType: {
            default: 'default'
        }
    },
    data() {
        return {
            form: {
                email: '',
                phone: '',
                paymentAmount: '',
                address: '',
                account: '',
                contract: ''
            },
            isTouchDevice: navigator.userAgent.includes('iPhone') || 
                navigator.userAgent.includes('iPad') || 
                navigator.userAgent.includes('iPod') || 
                navigator.userAgent.includes('Android'),
        }
    },
    methods: {
        checkValid() {
            this.$emit('check-valid', {
                step: 3,
                valid: !this.$v.$invalid
            })
        },
        nextStep() {
            if (!this.$v.$invalid) return this.form;
        },
        isValid(){
            return !this.$v.$invalid
        },
        isIe() {
            return navigator.userAgent.toLowerCase().includes('rv:11.0') && navigator.userAgent.toLowerCase().includes('trident/7.0')
        },
    },
    validations() {
        return {
            form: {
                email: {
                    required,
                    email,
                    maxLength: maxLength(100)
                },
                phone: {
                    required,
                    maxLength: maxLength(100),
                    isCorrectPhone: (param) => {
                        return param ? !/_/.test(param) : true;
                    }
                },
                paymentAmount: {
                    required,
                    maxLength: maxLength(7),
                },
                address: {
                    maxLength: maxLength(10000)
                },
                account: {
                    maxLength: maxLength(10000)
                },
                contract: {
                    maxLength: maxLength(100)
                }
            }
        }
    },
    mounted() {
        this.contactsInfo ? this.form = this.contactsInfo : '';
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/mixins-and-vars';

$parent: '.np-form-user-fields';

#{$parent} {
    display: flex;
    flex-direction: column;
    position: relative;
    animation: ezTransformOpacity .2s linear;
}
</style>
